import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query GetProductData($organisationId: ID!, $schemeType: ID!, $id: ID!, $brochureGroupId: ID!, $locale: String) {
    productDetail(locale: $locale, organisationId: $organisationId, schemeType: $schemeType, id: $id, brochureGroupId: $brochureGroupId) {
      employeeOrganisation {
        id
        scheme {
          id
          isNhs
          storeName
          brochureGroups {
            id
            term
          }
          product {
            id
            productId
            brochureGroupId
            name
            description
            price
            url
            image
            productTagName
            productTagImage
            productImages
            summary
            techSpecs
            supplierDesktopBanner
            supplierMobileBanner
            totalAmount
            brand
            category
            variant
            sku
            supplierName
            department
            savings
            recommendedRetailPrice
            reachedMaximumQuantity
            maximumQuantity
            status
            releaseDate
            preBackOrderProductMessage
            recommendations {
              id
              productId
              brochureGroupId
              name
              price
              totalAmount
              url
              image
              productTagName
              productTagImage
              term
              brand
              category
              variant
              sku
              supplierName
              department
            }
            recommendationsSimilarProducts {
              id
              productId
              brochureGroupId
              name
              price
              totalAmount
              url
              image
              productTagName
              productTagImage
              term
              brand
              category
              variant
              sku
              supplierName
              department
            }
            breadcrumbs {
              label
              link
              forceLink
            }
          }
        }
      }
    }
  }
`

export const getProductDetailQueryKey = getQueryNames(query)[0]
export default query
